import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const getUserIdByEmail = async (email: string) => {
    try {
        const response = await axios.post(`${API_URL}/user/UserIdByEmail`, { email });
        return response.data;
    } catch (error: any) {
        console.error('Error fetching user ID:', error);
        if (axios.isAxiosError(error)) {
            console.error('Axios Error Details:', error.response);
            throw new Error(error.response?.data?.message || 'Une erreur est survenue');
        } else {
            throw new Error('Une erreur est survenue');
        }
    }
};

export const resetPassword = async (data: any) => {
    const { id, newPassword } = data;
    try {
        const response = await axios.post(`${API_URL}/user/update-password/${id}`, {
            newPassword
        });
        return response.data;
    } catch (error: any) {
        console.error('Error while resetting password:', error);
        if (axios.isAxiosError(error)) {
            console.error('Axios Error Details:', error.response); // Afficher les détails de l'erreur Axios
            throw new Error(error.response?.data?.message || 'Une erreur est survenue');
        } else {
            throw new Error('Une erreur est survenue');
        }
    }
};
